import { render, staticRenderFns } from "./DataDictionary.vue?vue&type=template&id=4709b297"
import script from "./DataDictionary.vue?vue&type=script&lang=js"
export * from "./DataDictionary.vue?vue&type=script&lang=js"
import style0 from "./DataDictionary.vue?vue&type=style&index=0&id=4709b297&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports